const avatar           = require('../components/avatar/avatar')
const dtWebSocket      = require('../components/dt/dt-web-socket')
const entityRegistry   = require('../js/click-components-entity')
const monitor          = require('../components/monitor/monitor')
const monitorCommand   = require('../components/monitor/monitor-command')
const userdt           = require('../applications/staff/desktop/entity/users/users-dt')
const usersDtCommand   = require('../applications/staff/desktop/entity/users/users-dt-command')


//const userPreference   = require('../js-handler/user-preference')

//tv
const tvDashboardHomePage   = require('../applications/staff/tv/entity/tvDashboardHome/tvDashboardHome-page')


export function wsOnmessage(ev){ 


	const message = JSON.parse(ev);


	if(message.act != "pong" && message.act != "ping" ) 

    // on each messanger from the server (including pong) rotate 
    avatar.up() 

	switch (message.act){
    	 case 'pong'         :  return;                                break;
    	// case 'command'      :  monitorCommand.receiver(message);      break;
		// case 'monitor'      :  monitor.start(message.data);           break;
    	 case 'monitor'      :  userdt.start(message.data);            break;
      	 case 'command'      :  usersDtCommand.receiver(message);      break;
    	 //case 'entityUpdate' :  dtWebSocket.receiver(message.message); break;
    	 case 'entityUpdate' :  entityUpdate(message); break;

		//tv
    	case 'dashboardTv' :  dashboardTvMonitor.start(message.data); break;



	}
}




function entityUpdate(message){

    // Ejecuta la accion de la entidad indicada por el mensaje.
    if (message.message?.entityCall) {
        executeEntityFunction(message.message.entityCall);
        return;
    }

	//if we are on tv, just update the graphs and return, no table or fullcont
    var storeData = JSON.parse( localStorage.getItem('userPreference') )
	if(storeData.deviceType === 'tv' ){
		tvDashboardHomePage.update(message)		
		return
	}

	dtWebSocket.receiver(message.message)




}



// Usa el mismo enrutador de entidades que los eventos de la interfaz.
// Solo recibe nombres y datos: no ejecuta codigo enviado por el socket.
export function executeEntityFunction(entityCall) {
    if (!entityCall || typeof entityCall !== 'object') return;

    const entityName = entityCall.entity;
    const componentName = entityCall.elem;
    const functionName = entityCall.function;
    const entities = entityRegistry.obj_entity;

    if (typeof entityName !== 'string' || typeof componentName !== 'string' ||
        typeof functionName !== 'string' || !componentName || !functionName ||
        !Object.prototype.hasOwnProperty.call(entities, entityName)) {
        console.warn('WebSocket: entidad o funcion no valida.', entityCall);
        return;
    }

    const params = entityCall.params || {};
    const detail = {
        ...params,
        dest: entityName,
        entity: entityName,
        elem: componentName,
        act: functionName
    };

    try {
        entities[entityName].start(detail);
    } catch (error) {
        console.warn('WebSocket: no se pudo ejecutar la funcion de la entidad.', entityCall, error);
    }
}
